import { api } from "@/api"

type ExportMGTransactionsByMerchantReportQuery = {
  start: string
  end: string
}

export const exportMGTransactionsByMerchantReport = async (
  query: ExportMGTransactionsByMerchantReportQuery,
  format?: FileExportFormat
) => {
  const response = await api.get<Blob | string>(
    "/merchant-group/reports/transactions/by-merchant/export/",
    {
      query: { ...query, format },
      isMerchantGroup: true,
    }
  )
  downloadFileFromResponse(response)
}
